module.exports = require('./base').extend();
